import _ from 'underscore';
import {
  getFoldersLimitPerAccount,
  getImageAssetLimitPerAccount,
  getVideoAssetLimitPerAccount
} from '../model';

const containsErrorCodeInList = (errorList, searchErrorCode) => {
  const found = _.find(errorList, (err) => {
    const errorCodeInn = _.get(err, ['body', 'value', 0, 'Code'], '') || err;
    return errorCodeInn === searchErrorCode;
  });
  if (found) {
    return true;
  }

  return false;
};

export const processFolderSizeLimitError = ({ errorList, aid, logger }) => {
  if (errorList.length > 0 && containsErrorCodeInList(errorList, 'FolderLimitExceededPerAccount')) {
    const limit = getFoldersLimitPerAccount(aid, logger);

    return { limit };
  }

  return null;
};

export const processImageSizeLimitError = ({ errorList, aid, logger }) => {
  if (errorList.length > 0 && containsErrorCodeInList(errorList, 'ImagesLimitExceededPerAccount')) {
    const limit = getImageAssetLimitPerAccount(aid, logger);

    return { limit };
  }

  return null;
};

export const processVideoSizeLimitError = ({ errorList, aid, logger }) => {
  if (errorList.length > 0 && containsErrorCodeInList(errorList, 'VideoLimitExceededPerAccount')) {
    const limit = getVideoAssetLimitPerAccount(aid, logger);

    return { limit };
  }

  return null;
};
